import React from "react";
import {
  createIdentityProviders,
  updateIdentityProviders,
  deleteIdentityProviders,
} from "../../../action/SettingsApi";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { Backdrop, CircularProgress, TextField } from "@material-ui/core";
import { Button } from "react-bootstrap";
import { getSsoDetails } from "../../../action/SettingsApi";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import CommonIcon from "../../helpers/icons";
import API from "../../helpers/endpointservice";
import Action from "../../../action/api";

class SSO extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      identityProvider: "",
      currentIdentityProvider: "",
      clientId: "",
      clientSecret: "",
      tenantId: "",
      isloading: false,
      IsIdentityProviderEdit: true,
      IsIdentityProvidergoogleEdit: true,
      clientIdError: "",
      clientSecretError: "",
      TenantIdError: "",
      googleclientId: "",
      googleclientIdError: "",
      googleclientSecretError: "",
      googleAdminEmailError: "",
      googleJsonError: "",
      jsonFile: null,
      jsonFileName: "",
      uploadedJsonFileName: "",
      googleclientSecret: "",
      opendialog: false,
      cancelopendialog: false,
      toBeDeletedAccount: "",
      dialogforwarning: false,
      confirmed: false,
      requestBodyData: {},
      dialogforwarningcreate: false,
      adminUserEmail: "",
      tempData: null,
      changeCheck: false,
      tempRadioValue: null,
      isValueChanged: false,
      changeCancel: false,
    };
  }

  componentDidMount() {
    this.setState({ isloading: true });
    this.props
      .dispatch(getSsoDetails())
      .then((data) => {
        this.setState({ isloading: false });
        console.log(data);
        if (data && data.length > 0) {
          if (data[0].providerType == "microsoft") {
            this.setState({
              identityProvider: data[0].providerType || "none",
              currentIdentityProvider: data[0].providerType || "none",
              clientId: data[0].clientId || "",
              clientSecret: data[0].clientSecret || "",
              tenantId: data[0].microsoftTenantId || "",
              isloading: false,
              toBeDeletedAccount: data[0].providerType,
            });
          } else if (data[0].providerType == "google") {
            this.setState({
              identityProvider: data[0].providerType || "none",
              currentIdentityProvider: data[0].providerType || "none",
              googleclientId: data[0].clientId || "",
              googleclientSecret: data[0].clientSecret || "",
              tenantId: data[0].microsoftTenantId || "",
              isloading: false,
              toBeDeletedAccount: data[0].providerType,
              adminUserEmail: data[0].adminUserEmail,
              uploadedJsonFileName: data[0].fileName,
            });
          }
          this.setState({ tempData: data });
        } else {
          this.setState({
            isloading: false,
            identityProvider: "none",
            currentIdentityProvider: "none",
          });
        }
      })
      .catch((error) => {
        console.error("Failed to get SSO details:", error);
        this.setState({ isloading: false });
      });
  }

  handleradioCheck = (event) => {
    if (this.state.isValueChanged) {
      this.setState({ tempRadioValue: event });
      this.setState({ changeCheck: true });
    } else {
      this.handleChange(event);
    }
  };

  YesChanges = () => {
    this.setState({ changeCheck: false });
    this.handleChange(this.state.tempRadioValue);
  };

  NoChanges = () => {
    this.setState({ changeCheck: false, tempRadioValue: null });
    console.log(this.state.identityProvider);
  };

  handleChange = (event) => {
    this.setState({
      clientIdError: "",
      clientSecretError: "",
      TenantIdError: "",
      googleclientIdError: "",
      googleclientSecretError: "",
      googleAdminEmailError: "",
      googleJsonError: "",
      isValueChanged: false,
    });
    if (this.state.tempData) {
      if (this.state.tempData[0].providerType == "microsoft") {
        this.setState({
          clientId: this.state.tempData[0].clientId || "",
          clientSecret: this.state.tempData[0].clientSecret || "",
          tenantId: this.state.tempData[0].microsoftTenantId || "",
          isloading: false,
        });
      } else {
        this.setState({
          clientId: "",
          clientSecret: "",
          tenantId: "",
        });
      }
      if (this.state.tempData[0].providerType == "google") {
        this.setState({
          googleclientId: this.state.tempData[0].clientId || "",
          googleclientSecret: this.state.tempData[0].clientSecret || "",
          tenantId: this.state.tempData[0].microsoftTenantId || "",
          adminUserEmail: this.state.tempData[0].adminUserEmail || "",
          uploadedJsonFileName: this.state.tempData[0].fileName || "",
          jsonFile: null,
          jsonFileName: "",
          isloading: false,
        });
      } else {
        this.setState({
          googleclientId: "",
          googleclientSecret: "",
          isloading: false,
          adminUserEmail: "",
          jsonFile: null,
          jsonFileName: "",
          uploadedJsonFileName: "",
        });
      }
    } else {
      this.setState({
        clientId: "",
        clientSecret: "",
        tenantId: "",
        googleclientId: "",
        googleclientSecret: "",
        adminUserEmail: "",
        jsonFile: null,
        jsonFileName: "",
        uploadedJsonFileName: "",
      });
    }
    this.setState({ identityProvider: event.target.value });
  };

  handleFileChange = (e) => {
    this.setState({ isValueChanged: true });
    const file = e.target.files[0];
    if (file) {
      this.setState({
        jsonFile: file,
        jsonFileName: file.name,
        googleJsonError: "",
      });
    }
  };

  microsoftValidation = () => {
    if (this.state.clientId != "") {
      console.log(this.state.clientId);
      this.state.clientIdError = "";
    } else {
      this.state.clientIdError = "Client Id is missing";
    }
    if (this.state.clientSecret != "") {
      console.log(this.state.clientSecret);
      this.state.clientSecretError = "";
    } else {
      this.state.clientSecretError = "Client secret is missing";
    }
    if (this.state.tenantId != "") {
      console.log(this.state.tenantId);
      this.state.TenantIdError = "";
    } else {
      this.state.TenantIdError = "Tenant Id is missing";
    }
  };
  googleValidation = () => {
    if (this.state.googleclientId.trim() != "") {
      this.state.googleclientIdError = "";
    } else {
      this.state.googleclientIdError = "Client Id is missing";
    }
    if (this.state.googleclientSecret.trim() != "") {
      this.state.googleclientSecretError = "";
    } else {
      this.state.googleclientSecretError = "Client secret is missing";
    }

    if (this.state.adminUserEmail.trim() !== "") {
      this.state.googleAdminEmailError = "";
    } else {
      this.state.googleAdminEmailError = "Domain admin email is missing";
    }
    if (!this.state.uploadedJsonFileName) {
      if (this.state.jsonFile == null) {
        this.setState({
          googleJsonError: "Upload secret json file",
        });
      } else {
        this.setState({ googleJsonError: "" });
      }
    }
  };
  handleAdd = () => {
    console.log("hello");

    if (this.state.identityProvider != "none") {
      console.log(this.state.identityProvider, "idemtity");
      this.microsoftValidation();
      this.googleValidation();
      this.props.dispatch(getSsoDetails()).then((data) => {
        console.log(data);
        if (data.length > 0) {
          if (
            data[0].providerType != "" &&
            this.state.identityProvider == "microsoft"
          ) {
            if (
              this.state.clientId.trim() != "" &&
              this.state.clientSecret.trim() != "" &&
              this.state.tenantId.trim() != ""
            ) {
              this.setState({
                requestBodyData: {
                  clientId: this.state.clientId.toString(),
                  clientSecret: this.state.clientSecret.toString(),
                  providerType: "microsoft",
                  internalId: data[0].internalId,
                  isActive: true,
                  identityProviderId: data[0].identityProviderId,
                  isChangedFromPreviousProvider: true,
                  microsoftTenantId: this.state.tenantId.toString(),
                },
              });
              this.setState({ dialogforwarning: true });
            }
          } else if (
            data[0].providerType != "" &&
            this.state.identityProvider == "google"
          ) {
            console.log("already google exist");

            if (
              this.state.googleclientId.trim() != "" &&
              this.state.googleclientSecret.trim() != "" &&
              this.state.adminUserEmail.trim() !== "" &&
              (this.state.uploadedJsonFileName || this.state.jsonFile)
            ) {
              this.setState({
                requestBodyData: {
                  clientId: this.state.googleclientId.toString(),
                  clientSecret: this.state.googleclientSecret.toString(),
                  providerType: "google",
                  internalId: data[0].internalId,
                  isActive: true,
                  identityProviderId: data[0].identityProviderId,
                  isChangedFromPreviousProvider: true,
                  microsoftTenantId: "",
                },
              });

              this.setState({ dialogforwarning: true });
              // this.state.clientId=this.state.clientSecret=this.state.tenantId="";
              // this.state.IsIdentityProvidergoogleEdit=false;
            }
          }
        } else {
          if (this.state.identityProvider == "microsoft") {
            this.microsoftValidation();
            if (
              this.state.clientId.trim() != "" &&
              this.state.clientSecret.trim() != "" &&
              this.state.tenantId.trim() != ""
            ) {
              this.setState({ dialogforwarningcreate: true });
              this.setState({
                requestBodyData: {
                  clientId: this.state.clientId.toString(),
                  clientSecret: this.state.clientSecret.toString(),
                  providerType: "microsoft",
                  internalId: "",
                  isActive: true,
                  identityProviderId: "",
                  isChangedFromPreviousProvider: true,
                  microsoftTenantId: this.state.tenantId.toString(),
                },
              });
            }
          } else if (this.state.identityProvider == "google") {
            this.googleValidation();
            if (
              this.state.googleclientId.trim() != "" &&
              this.state.googleclientSecret.trim() != "" &&
              this.state.adminUserEmail.trim() !== "" &&
              (this.state.uploadedJsonFileName || this.state.jsonFile)
            ) {
              this.setState({ dialogforwarningcreate: true });
              this.setState({
                requestBodyData: {
                  clientId: this.state.googleclientId.toString(),
                  clientSecret: this.state.googleclientSecret.toString(),
                  providerType: "google",
                  internalId: "",
                  isActive: true,
                  identityProviderId: "",
                  isChangedFromPreviousProvider: true,
                  microsoftTenantId: this.state.tenantId.toString(),
                },
              });

              //    this.state.IsIdentityProvidergoogleEdit=false;
            }
          }
        }
      });
    }
  };

  noActions = () => {
    this.setState({ opendialog: false });
  };

  yesActions = () => {
    this.setState({ opendialog: false });
    if (this.state.toBeDeletedAccount) {
      // this.props.dispatch(
      //   deleteIdentityProviders(this.state.toBeDeletedAccount)
      // );
      const { dispatch } = this.props;
      dispatch({ type: "IS_LOADER", data: true });
      Action.DELETE(`${API.DELETE_SSO_DETAILS}${this.state.toBeDeletedAccount}`)
        .then((res) => {
          if (res.status == 200) {
            dispatch({ type: "DELETE_SSO_LOADED_SUCCESS", data: res.data });
            dispatch({ type: "IS_LOADER", data: false });
          }
          this.props.handleLogout();
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
        })
        .catch((error) => {
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
        });
    }
    this.state.clientId =
      this.state.clientSecret =
      this.state.tenantId =
      this.state.googleclientId =
      this.state.googleclientSecret =
        "";
  };

  none = () => {
    this.setState({ opendialog: true });
    console.log(this.state.identityProvider);
  };

  handleUpdate = () => {
    if (this.state.identityProvider == "microsoft") {
      this.setState({ IsIdentityProviderEdit: true });
    } else {
      this.setState({ IsIdentityProvidergoogleEdit: true });
    }
  };

  noAction = () => {
    this.setState({ cancelopendialog: false });
  };

  yesActionss = () => {
    this.setState({ dialogforwarning: false });
    this.props
      .dispatch(updateIdentityProviders(this.state.requestBodyData))
      .then((res) => {
        if (this.state.requestBodyData.providerType == "google") {
          this.updateGoogleCredentials(
            this.state.uploadedJsonFileName
              ? this.state.jsonFile
                ? true
                : false
              : this.state.jsonFile
              ? true
              : false
          );
        } else {
          this.props.handleLogout();
        }
      });
  };

  noActionss = () => {
    this.setState({ dialogforwarning: false });
  };

  yesActionssss = () => {
    this.setState({ dialogforwarningcreate: false });
    this.props
      .dispatch(createIdentityProviders(this.state.requestBodyData))
      .then((res) => {
        if (this.state.requestBodyData.providerType == "google") {
          this.updateGoogleCredentials(
            this.state.uploadedJsonFileName
              ? this.state.jsonFile
                ? true
                : false
              : this.state.jsonFile
              ? true
              : false
          );
        } else {
          this.props.handleLogout();
        }
        this.state.clientId =
          this.state.clientSecret =
          this.state.tenantId =
          this.state.googleclientId =
          this.state.googleclientSecret =
            "";
        // this.state.IsIdentityProvidergoogleEdit = false;
        // this.state.IsIdentityProviderEdit = false
      });
  };

  noActionssss = () => {
    this.setState({ dialogforwarningcreate: false });
  };

  yesAction = () => {
    this.setState({ cancelopendialog: false });
    // this.setState({ cancelopendialog: false, IsIdentityProvidergoogleEdit: false, IsIdentityProviderEdit: false });
  };

  closeForm = () => {
    // Handle form close logic
    this.setState({ cancelopendialog: true });
  };

  cancelAction = () => {
    if (this.state.isValueChanged) {
      this.setState({ changeCancel: true });
    } else {
      this.resetSSO();
    }
  };

  downloadBase64File = (fileData) => {
    const { fileContentBase64, fileName, contentType } = fileData;

    // Decode base64 and create a Blob
    const byteCharacters = atob(fileContentBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });

    // Create a download link and trigger it
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  downloadFile = () => {
    this.setState({ isloading: true });
    Action.GET(API.GoogleAdmin)
      .then((res) => {
        if (res.data) {
          this.downloadBase64File(res.data);
          this.setState({ isloading: false });
        }
      })
      .catch((error) => {
        this.setState({ isloading: false });
        console.log(error);
      });
  };

  updateGoogleCredentials = (value) => {
    this.setState({ isloading: true });
    const params = new URLSearchParams({
      adminUserEmail: this.state.adminUserEmail,
      isFileUpdated: value,
    }).toString();
    const formData = new FormData();
    if (this.state.jsonFile) {
      formData.append("file", this.state.jsonFile);
    }

    Action.PUT(`${API.GoogleAdmin}?${params}`, formData)
      .then((res) => {
        if (res.data) {
          this.setState({ isloading: false });
        }
        this.props.handleLogout();
      })
      .catch((error) => {
        this.setState({ isloading: false });
        console.log(error);
      });
  };

  resetSSO = () => {
    this.setState({
      clientIdError: "",
      clientSecretError: "",
      TenantIdError: "",
      googleclientIdError: "",
      googleclientSecretError: "",
      googleAdminEmailError: "",
      googleJsonError: "",
      isValueChanged: false,
    });
    if (this.state.tempData) {
      if (this.state.tempData[0].providerType == "microsoft") {
        this.setState({
          clientId: this.state.tempData[0].clientId || "",
          clientSecret: this.state.tempData[0].clientSecret || "",
          tenantId: this.state.tempData[0].microsoftTenantId || "",
          isloading: false,
          identityProvider: this.state.tempData[0].providerType || "none",
          toBeDeletedAccount: this.state.tempData[0].providerType,
        });
      } else {
        this.setState({
          clientId: "",
          clientSecret: "",
          tenantId: "",
        });
      }
      if (this.state.tempData[0].providerType == "google") {
        this.setState({
          googleclientId: this.state.tempData[0].clientId || "",
          googleclientSecret: this.state.tempData[0].clientSecret || "",
          tenantId: this.state.tempData[0].microsoftTenantId || "",
          isloading: false,
          identityProvider: this.state.tempData[0].providerType || "none",
          toBeDeletedAccount: this.state.tempData[0].providerType,
          adminUserEmail: this.state.tempData[0].adminUserEmail || "",
          uploadedJsonFileName: this.state.tempData[0].fileName || "",
          jsonFile: null,
          jsonFileName: "",
        });
      } else {
        this.setState({
          googleclientId: "",
          googleclientSecret: "",
          isloading: false,
          adminUserEmail: "",
          jsonFile: null,
          jsonFileName: "",
          uploadedJsonFileName: "",
        });
      }
    } else {
      this.setState({
        clientId: "",
        clientSecret: "",
        tenantId: "",
        googleclientId: "",
        googleclientSecret: "",
        identityProvider: "none",
        toBeDeletedAccount: "",
      });
    }
  };

  render() {
    const {
      identityProvider,
      currentIdentityProvider,
      clientId,
      clientSecret,
      tenantId,
      isloading,
      googleclientId,
      googleclientSecret,
    } = this.state;
    return (
      <div className="pt13">
        <Backdrop className="spinner-backdrop" open={isloading}>
          <CircularProgress color="primary" />
        </Backdrop>
        <div className="row d-flex align-items-center">
          <div className="col-12  d-flex align-items-center">
            <span className="joblable">Identity Provider</span>
          </div>
          <div className="col-12 mt-2">
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={identityProvider}
                onChange={this.handleradioCheck}
                className="ssoradio"
              >
                <FormControlLabel
                  className="border-none p-no"
                  value="none"
                  //   onClick={() => {
                  //     this.none();
                  //   }}
                  control={<Radio />}
                  label="None"
                />
                <FormControlLabel
                  className="border-none p-no"
                  value="google"
                  disabled={
                    this.props.isSSO &&
                    currentIdentityProvider &&
                    currentIdentityProvider !== "google"
                  }
                  control={<Radio />}
                  label="Google"
                />
                <FormControlLabel
                  className="border-none p-no"
                  value="microsoft"
                  disabled={
                    this.props.isSSO &&
                    currentIdentityProvider &&
                    currentIdentityProvider !== "microsoft"
                  }
                  control={<Radio />}
                  label="Microsoft"
                />
              </RadioGroup>
            </FormControl>
          </div>
        </div>
        {identityProvider == "none" && this.state.toBeDeletedAccount !== "" && (
          <div className="row mt-2">
            {/* <div className="col-2 mt-10">
              <span className="joblable"></span>
            </div> */}
            <div className="col-12 ">
              <button
                className="btn-fun btn-action btn-filter-action"
                variant="primary"
                onClick={() => {
                  // this.yesActions();
                  this.setState({ opendialog: true });
                }}
              >
                Update
              </button>
              {/* <Button
                className="btn-cancel"
                variant="outlined"
                onClick={() => this.cancelAction()}
              >
                Cancel
              </Button> */}
            </div>
          </div>
        )}
        {identityProvider === "microsoft" && (
          <div className="row ">
            {/* <div className="col-12 py-0 my-0">
              <hr thickness={2} className="p-0 m-0" />
            </div> */}
            {/* <div className="col-2 mt-3">
              <span className="joblable">Microsoft</span>
            </div> */}
            {!this.state.IsIdentityProviderEdit && (
              <>
                <div className="col-12 3 mb-2 ssocontent">
                  <FormLabel
                    className="formlabel-style w-100 mb-2"
                    id="first-name-label"
                  >
                    Client Id
                  </FormLabel>
                  <span className="wrap">{clientId}</span>

                  <FormLabel
                    className="formlabel-style w-100 mt-11 mb-2"
                    id="first-name-label"
                  >
                    Client Secret
                  </FormLabel>
                  <span className="wrap">{clientSecret}</span>

                  <FormLabel
                    className="formlabel-style w-100 mt-11 mb-2"
                    id="first-name-label"
                  >
                    Tenant Id
                  </FormLabel>
                  <span className="wrap">{tenantId}</span>
                  <div className="col-12  ssobutton">
                    <button
                      className="btn-action mt-10 mr-10 border-none"
                      variant="primary"
                      onClick={() => this.handleUpdate()}
                    >
                      Update
                    </button>{" "}
                  </div>
                </div>
              </>
            )}

            {this.state.IsIdentityProviderEdit && (
              <>
                <div className="col-12 ssocontent">
                  <div className="col-12 mt-2 mb-4 ">
                    <FormLabel
                      className="formlabel-style w-100 mb-2 "
                      id="first-name-label"
                    >
                      Client Id
                      <span
                        className={`isrequired ${
                          this.state.view === true ||
                          (this.props.isSSO &&
                            currentIdentityProvider == "microsoft")
                            ? "d-none"
                            : ""
                        }`}
                      >
                        *
                      </span>
                    </FormLabel>
                    <TextField
                      error={this.state.clientIdError}
                      id="ClientId"
                      variant="filled"
                      disabled={
                        this.props.isSSO &&
                        currentIdentityProvider == "microsoft"
                      }
                      value={clientId}
                      style={{ width: "50%" }}
                      className="inputwidth"
                      onChange={(e) =>
                        this.setState({
                          clientId: e.target.value,
                          isValueChanged: true,
                        })
                      }
                    />
                    {this.state.clientIdError && (
                      <div className="error-message" style={{ color: "red" }}>
                        {this.state.clientIdError}
                      </div>
                    )}

                    <FormLabel
                      className="formlabel-style w-100 mt-11 mb-2"
                      id="first-name-label"
                    >
                      Client Secret
                      <span
                        className={`isrequired ${
                          this.state.view === true ? "d-none" : ""
                        }`}
                      >
                        *
                      </span>
                    </FormLabel>
                    <TextField
                      error={this.state.clientSecretError}
                      id="ClientSecret"
                      variant="filled"
                      value={clientSecret}
                      style={{ width: "50%" }}
                      className="inputwidth"
                      onChange={(e) =>
                        this.setState({
                          clientSecret: e.target.value,
                          isValueChanged: true,
                        })
                      }
                    />
                    {this.state.clientSecretError && (
                      <div className="error-message" style={{ color: "red" }}>
                        {this.state.clientSecretError}
                      </div>
                    )}

                    <FormLabel
                      className="formlabel-style w-100 mt-11 mb-2"
                      id="first-name-label"
                    >
                      Tenant Id
                      <span
                        className={`isrequired ${
                          this.state.view === true ||
                          (this.props.isSSO &&
                            currentIdentityProvider == "microsoft")
                            ? "d-none"
                            : ""
                        }`}
                      >
                        *
                      </span>
                    </FormLabel>
                    <TextField
                      error={this.state.TenantIdError}
                      id="TenantId"
                      variant="filled"
                      value={tenantId}
                      style={{ width: "50%" }}
                      disabled={
                        this.props.isSSO &&
                        currentIdentityProvider == "microsoft"
                      }
                      className="inputwidth"
                      onChange={(e) =>
                        this.setState({
                          tenantId: e.target.value,
                          isValueChanged: true,
                        })
                      }
                    />
                    {this.state.TenantIdError && (
                      <div className="error-message" style={{ color: "red" }}>
                        {this.state.TenantIdError}
                      </div>
                    )}
                  </div>
                  <div className="col-2"></div>
                  <div className="col-10">
                    <div className="col-12 pb-20 pr-28 ssobutton">
                      <button
                        className={`btn-fun btn-action btn-filter-action`}
                        variant="primary"
                        onClick={(e) => this.handleAdd(e)}
                      >
                        Update
                      </button>
                      {/* {(!this.state.tempData ||
                        this.state.tempData.length === 0 ||
                        this.state.toBeDeletedAccount !==
                          this.state.tempData?.[0]?.providerType) && (
                        <Button
                          className="btn-cancel"
                          variant="outlined"
                          onClick={() => this.cancelAction()}
                        >
                          Cancel
                        </Button>
                      )} */}
                      {/* <Button data-bs-dismiss="offcanvas" className={`btn-cancel btn-filter-action`} variant="outlined" onClick={this.closeForm}>Cancel</Button> */}
                    </div>
                    {/* <hr thickness={2} /> */}
                  </div>
                </div>
              </>
            )}
          </div>
        )}
        {identityProvider === "google" && (
          <div className="row ">
            {/* <div className="col-12 py-0 my-0">
              <hr thickness={2} className="p-0 m-0" />
            </div> */}
            {/* <div className="col-2 mt-10">
              <span className="joblable">Google</span>
            </div> */}
            {!this.state.IsIdentityProvidergoogleEdit && (
              <>
                <div className="col-12 mt-10 mb-2 ssocontent">
                  <FormLabel
                    className="formlabel-style w-100 mb-2"
                    id="first-name-label"
                  >
                    Client Id
                  </FormLabel>
                  <span className="wrap">{this.state.googleclientId}</span>

                  <FormLabel
                    className="formlabel-style w-100 mt-11 mb-2"
                    id="first-name-label"
                  >
                    Client Secret
                  </FormLabel>
                  <span className="wrap">{this.state.googleclientSecret}</span>
                  <div className="col-12 ssobutton">
                    <button
                      className="btn-action mt-10 mr-10 border-none"
                      variant="primary"
                      onClick={() => this.handleUpdate()}
                    >
                      Update
                    </button>{" "}
                    {/* <Button className='btn-cancel mt-10' variant="outlined" onClick={() => this.cancel()} >Cancel</Button>{' '} */}
                  </div>
                  {/* <hr thickness={2} /> */}
                </div>
              </>
            )}

            {this.state.IsIdentityProvidergoogleEdit && (
              <>
                <div className="col-12 mt-2 mb-4 ssocontent">
                  <FormLabel
                    className="formlabel-style w-100 mb-2"
                    id="first-name-label"
                  >
                    Client Id
                    <span
                      className={`isrequired ${
                        this.state.view === true ||
                        (this.props.isSSO &&
                          currentIdentityProvider == "google")
                          ? "d-none"
                          : ""
                      }`}
                    >
                      *
                    </span>
                  </FormLabel>
                  <TextField
                    error={this.state.googleclientIdError}
                    id="googlecliengtId"
                    variant="filled"
                    disabled={
                      this.props.isSSO && currentIdentityProvider == "google"
                    }
                    value={googleclientId}
                    style={{ width: "50%" }}
                    onChange={(e) =>
                      this.setState({
                        googleclientId: e.target.value,
                        isValueChanged: true,
                      })
                    }
                    className="inputwidth"
                  />
                  {this.state.googleclientIdError && (
                    <div className="error-message" style={{ color: "red" }}>
                      {this.state.googleclientIdError}
                    </div>
                  )}
                  <FormLabel
                    className="formlabel-style w-100 mt-11 mb-2"
                    id="first-name-label"
                  >
                    Client Secret
                    <span
                      className={`isrequired ${
                        this.state.view === true ? "d-none" : ""
                      }`}
                    >
                      *
                    </span>
                  </FormLabel>
                  <TextField
                    error={this.state.googleclientSecretError}
                    id="googleclinetsecret"
                    variant="filled"
                    value={googleclientSecret}
                    style={{ width: "50%" }}
                    onChange={(e) =>
                      this.setState({
                        googleclientSecret: e.target.value,
                        isValueChanged: true,
                      })
                    }
                    className="inputwidth"
                  />
                  {this.state.googleclientSecretError && (
                    <div className="error-message" style={{ color: "red" }}>
                      {this.state.googleclientSecretError}
                    </div>
                  )}
                  <FormLabel
                    className="formlabel-style w-100 mt-11 mb-2"
                    id="first-name-label"
                  >
                    Domain Admin Email
                    <span
                      className={`isrequired ${
                        this.state.view === true ||
                        (this.props.isSSO &&
                          currentIdentityProvider == "google")
                          ? "d-none"
                          : ""
                      }`}
                    >
                      *
                    </span>
                  </FormLabel>
                  <TextField
                    error={this.state.googleAdminEmailError}
                    id="googleclinetsecret"
                    variant="filled"
                    disabled={
                      this.props.isSSO && currentIdentityProvider == "google"
                    }
                    value={this.state.adminUserEmail}
                    style={{ width: "50%" }}
                    onChange={(e) =>
                      this.setState({
                        adminUserEmail: e.target.value,
                        isValueChanged: true,
                      })
                    }
                    className="inputwidth"
                  />
                  {this.state.googleAdminEmailError && (
                    <div className="error-message" style={{ color: "red" }}>
                      {this.state.googleAdminEmailError}
                    </div>
                  )}
                  <FormLabel
                    className="formlabel-style w-100 mb-2 mt-11"
                    id="first-name-label"
                  >
                    Secret JSON
                    <span
                      className={`isrequired ${
                        this.state.view === true ||
                        (this.props.isSSO &&
                          currentIdentityProvider == "google")
                          ? "d-none"
                          : ""
                      }`}
                    >
                      *
                    </span>
                  </FormLabel>
                  <label
                    htmlFor="customFileLang"
                    className={`fileUploadSSO ${
                      this.props.isSSO && currentIdentityProvider == "google"
                        ? " disabled"
                        : ""
                    }`}
                  >
                    <CommonIcon fileName={"FileUpload"} />
                  </label>
                  <span className="uploadedFile">
                    {this.state.jsonFileName || "Only JSON file is supported"}
                  </span>
                  {this.state.uploadedJsonFileName && (
                    <div className="d-flex align-items-center mt-2">
                      <span className="formlabel-input">
                        {this.state.uploadedJsonFileName}
                      </span>
                      {this.state.uploadedJsonFileName && (
                        <>
                          <span
                            className="ms-2 cursor-pointer"
                            onClick={() => {
                              this.downloadFile();
                            }}
                          >
                            <CommonIcon fileName={"downloadBlue"} />
                          </span>
                        </>
                      )}
                    </div>
                  )}
                  <div className="custom-file d-none">
                    <input
                      type="file"
                      disabled={
                        this.props.isSSO && currentIdentityProvider == "google"
                      }
                      className="custom-file-input d-none"
                      id="customFileLang"
                      lang="es"
                      data-toggle="tooltip"
                      onChange={this.handleFileChange}
                      accept=".json"
                    />
                    {/* <label className="custom-file-label">{fileName}</label> */}
                  </div>
                  {this.state.googleJsonError && (
                    <div className="mui-error-text mt-1 ms-0">
                      {this.state.googleJsonError}
                    </div>
                  )}
                  <div className="col-12 pb-20 mt-3 pr-28 ssobutton">
                    <button
                      className={`btn-fun btn-action btn-filter-action ${
                        this.state.view || this.state.editUser === true
                          ? "d-none"
                          : ""
                      }`}
                      variant="primary"
                      onClick={() => this.handleAdd()}
                    >
                      Update
                    </button>
                    <button
                      className={`btn-fun btn-action btn-filter-action ${
                        this.state.editUser === true ? "" : "d-none"
                      }`}
                      variant="primary"
                      onClick={() => this.handleUpdate()}
                    >
                      Update
                    </button>
                    {/* {(!this.state.tempData ||
                      this.state.tempData.length === 0 ||
                      this.state.toBeDeletedAccount !==
                        this.state.tempData?.[0]?.providerType) && (
                      <Button
                        className="btn-cancel"
                        variant="outlined"
                        onClick={() => this.cancelAction()}
                      >
                        Cancel
                      </Button>
                    )} */}
                  </div>
                  {/* <hr thickness={2} /> */}
                </div>
                {/* <div className="col-2"></div> */}
                <div className="row col-10"></div>
              </>
            )}
          </div>
        )}
        <div
          className={`modal modal-style viewbar-overlay  ${
            this.state.changeCancel ? "show" : ""
          }`}
          id="Additionform"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: this.state.changeCancel ? "block" : "none" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg bg-white rounded">
              <div className="modal-body text-center">
                <span>
                  {"Changes are not saved yet"}
                  <br />
                </span>
                <span>{"are you sure you want to close ?"}</span>
              </div>
              <div className="modal-footer justify-content-center">
                <Button
                  className="btn-no px-4"
                  variant="primary"
                  onClick={() => {
                    this.setState({ changeCancel: false });
                  }}
                >
                  No
                </Button>{" "}
                <Button
                  className="btn-action px-4"
                  variant="primary"
                  onClick={() => {
                    this.setState({ changeCancel: false });
                    this.resetSSO();
                  }}
                >
                  Yes
                </Button>{" "}
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal modal-style viewbar-overlay  ${
            this.state.changeCheck ? "show" : ""
          }`}
          id="Additionform"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: this.state.changeCheck ? "block" : "none" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg bg-white rounded">
              <div className="modal-body text-center">
                <span>
                  {"Changes are not saved yet"}
                  <br />
                </span>
                <span>{"are you sure you want to close ?"}</span>
              </div>
              <div className="modal-footer justify-content-center">
                <Button
                  className="btn-no px-4"
                  variant="primary"
                  onClick={() => this.NoChanges()}
                >
                  No
                </Button>{" "}
                <Button
                  className="btn-action px-4"
                  variant="primary"
                  onClick={() => this.YesChanges()}
                >
                  Yes
                </Button>{" "}
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal modal-style viewbar-overlay  ${
            this.state.opendialog ? "show" : ""
          }`}
          id="Additionform"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: this.state.opendialog ? "block" : "none" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg bg-white rounded">
              <div className="modal-body text-center">
                <span>
                  {"You will be logged out after this change."}
                  <br />
                </span>
                <span>{"Please log in again."}</span>
              </div>
              <div className="modal-footer justify-content-center">
                <Button
                  className="btn-no1 px-4"
                  variant="primary"
                  onClick={() => this.noActions()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  className="btn-action px-4"
                  variant="primary"
                  onClick={() => this.yesActions()}
                >
                  Ok
                </Button>{" "}
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal modal-style viewbar-overlay  ${
            this.state.cancelopendialog ? "show" : ""
          }`}
          id="Additionform"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: this.state.cancelopendialog ? "block" : "none" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg bg-white rounded">
              <div className="modal-body text-center">
                <span>{"Are you sure to change ?"}</span>
              </div>
              <div className="modal-footer justify-content-center">
                <Button
                  className="btn-no px-4"
                  variant="primary"
                  onClick={() => this.noAction()}
                >
                  No
                </Button>{" "}
                <Button
                  className="btn-action px-4"
                  variant="primary"
                  onClick={() => this.yesAction()}
                >
                  Yes
                </Button>{" "}
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal modal-style viewbar-overlay  ${
            this.state.dialogforwarning ? "show" : ""
          }`}
          id="Additionform"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: this.state.dialogforwarning ? "block" : "none" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg bg-white rounded">
              <div className="modal-body text-center">
                <span>
                  {"You will be logged out after this change."}
                  <br />
                </span>
                <span>{"Please log in again."}</span>
              </div>
              <div className="modal-footer justify-content-center">
                <Button
                  className="btn-no1 px-4"
                  variant="primary"
                  onClick={() => this.noActionss()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  className="btn-action px-4"
                  variant="primary"
                  onClick={() => this.yesActionss()}
                >
                  Ok
                </Button>{" "}
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal modal-style viewbar-overlay  ${
            this.state.dialogforwarningcreate ? "show" : ""
          }`}
          id="Additionform"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{
            display: this.state.dialogforwarningcreate ? "block" : "none",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg bg-white rounded">
              <div className="modal-body text-center">
                <span>
                  {"You will be logged out after this change."}
                  <br />
                </span>
                <span>{"Please log in again."}</span>
              </div>
              <div className="modal-footer justify-content-center">
                <Button
                  className="btn-no1 px-4"
                  variant="primary"
                  onClick={() => this.noActionssss()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  className="btn-action px-4"
                  variant="primary"
                  onClick={() => this.yesActionssss()}
                >
                  Ok
                </Button>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  getSsoDetails: state.settingsReducer.getSsoDetails,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SSO));
